module.exports = __webpack_public_path__ + "static/media/galdisa_blogImg9.2b3c34de.jpg";